import {PriceLine, PriceRider} from "../../../../../api/Pricing";
import {QuotePriceLine, QuotePriceRider} from "../../../../../api/QuotePricing";
import {hollowMetalDoor, hollowMetalFrame} from "../../openings/Const";
import {PriceSectionNote} from "../../../../../api/QuotePriceSectionNotes";
import {orderByAscending} from "nate-react-api-helpers";
import {SubCategories} from "../QuotePDF";
import {QuotePDFBuilder} from "./QuotePDFBuilder";

const isHmDoor = (input: PriceLine|QuotePriceLine) => input.productType === "door" && input.door.series === hollowMetalDoor;
const isHmDoorRider = (input: PriceRider|QuotePriceRider) => input.productType === "door" && (input.sectionKey === "door-hm" || input.sectionKey === "door-riders/hm");
const isHmDoorPrep = (input: PriceLine|QuotePriceLine) => input.productType === "door-prep" && input.doorSeries === hollowMetalDoor;
const isHmDoorPrepRider = (input: PriceRider|QuotePriceRider) => input.productType === "door-prep" && input.sectionKey === "door-prep/hm";
const isHmFrame = (input: PriceLine|QuotePriceLine) => input.productType === "frame" && input.frame.series === hollowMetalFrame;
const isHmFrameRider = (input: PriceRider|QuotePriceRider) => input.productType === "frame";
const isHmFramePrep = (input: PriceLine|QuotePriceLine) => input.productType === "frame-prep" && input.frameSeries === hollowMetalFrame;
const isHmFramePrepRider = (input: PriceRider|QuotePriceRider) => input.productType === "frame-prep";
const isHmFrameAnchor = (input: PriceLine|QuotePriceLine) => input.productType === "frame-anchor";
const isHmFrameAnchorRider = (input: PriceRider|QuotePriceRider) => input.productType === "frame-anchor"

// Hollow metal section has both doors and frames in it
export function addHmDoors(bld: QuotePDFBuilder, props: {
    riders: (PriceRider | QuotePriceRider)[];
    prices: (PriceLine | QuotePriceLine)[];
    notes: PriceSectionNote[]
}) {

    const hmNotes = props.notes.filter(n => n.keyName === "door" || n.keyName === "frame");
    orderByAscending(hmNotes, i => i.keyName === "frame" ? 0 : 1);

    const categories: SubCategories[] = [];
    categories.push({
        name: "Doors",
        filter: (i: PriceLine | QuotePriceLine) => isHmDoor(i) || isHmDoorPrep(i),
        filterRider: (i: PriceRider | QuotePriceRider) => isHmDoorRider(i) || isHmDoorPrepRider(i),

        children: [
            {
                name: "Doors",
                filter: isHmDoor,
                filterRider: isHmDoorRider,
                adminExcludeRiders: true,
            }, {
                name: "Door Preps",
                filter: isHmDoorPrep,
                filterRider: isHmDoorPrepRider,
                adminExcludeRiders: true,
            },
            !bld.excludeRiders && {
                name: "Door Riders",
                filter: () => false,
                filterRider: (i: PriceRider | QuotePriceRider) => isHmDoorRider(i) || isHmDoorPrepRider(i),
            }
        ]
    });

    categories.push({
        name: "Frames",
        filter: (i: PriceLine | QuotePriceLine) => isHmFrame(i) || isHmFramePrep(i) || isHmFrameAnchor(i),
        filterRider: (i: PriceRider | QuotePriceRider) => isHmFrameRider(i) || isHmFramePrepRider(i) || isHmFrameAnchorRider(i),
        children: [
            {
                name: "Frames",
                filter: isHmFrame,
                filterRider: isHmFrameRider,
                adminExcludeRiders: true,
            }, {
                name: "Frame Anchors",
                filter: isHmFrameAnchor,
                filterRider: isHmFrameAnchorRider,
                adminExcludeRiders: true,
            }, {
                name: "Frame Preps",
                filter: isHmFramePrep,
                filterRider: isHmFramePrepRider,
                adminExcludeRiders: true,
            },
            !bld.excludeRiders && {
                name: "Frame Riders",
                filter: () => false,
                filterRider: (i: PriceRider | QuotePriceRider) => isHmFrameRider(i) || isHmFramePrepRider(i) || isHmFrameAnchorRider(i),
            }
        ]
    })

    const hmRiders = props.riders.filter(r => {
        if(isHmDoorRider(r) || isHmDoorPrepRider(r)) return true;
        if(isHmFrameRider(r) || isHmFramePrepRider(r) || isHmFrameAnchorRider(r)) return true;

        return false;
    });

    const hmPrices = props.prices.filter(i => {
        if(isHmDoor(i) || isHmDoorPrep(i)) return true;
        if(isHmFrame(i) || isHmFramePrep(i) || isHmFrameAnchor(i)) return true;
        return false;
    });

    orderByAscending(hmPrices, i => i.productType === "frame" ? 0 : 1)
    bld.addSection({
            title: "Hollow Metal",
            note: hmNotes.map(n => n.note),
            categories: categories,
        },
        hmPrices as PriceLine[] | QuotePriceLine[],
        hmRiders
    );
}
